import antdLocale from '@aplus-frontend/antdv/es/locale/en_US';
// const modules = import.meta.glob('./en_US/**/*.{json,ts,js}', { eager: true });
import login from './login.json';
export default {
  antdLocale,
  login
};
